module.exports = __webpack_public_path__ + "img/data_analysis_bac1.d1635b06.png";